import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('cdm_user')); } catch { return null; }
  });
  const [loading, setLoading] = useState(false);

  const login = async (email, password) => {
    const res = await api.post('/auth/login', { email, password });
    localStorage.setItem('cdm_token', res.data.token);
    localStorage.setItem('cdm_user', JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = () => {
    localStorage.removeItem('cdm_token');
    localStorage.removeItem('cdm_user');
    setUser(null);
  };

  const isAdmin = user?.rol === 'admin';
  const isSupervisor = ['admin', 'supervisor'].includes(user?.rol);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, isAdmin, isSupervisor }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
